import React, { useEffect, useState } from "react";
import { ReactComponent as IconCloseCircle } from "../../../build/images/platformnps/closecircle.svg";
import { ReactComponent as IconWhatsapp } from "../../../build/images/platformnps/whatsapp.svg";
import { ReactComponent as IconPermPhone } from "../../../build/images/platformnps/permphone.svg";
import { ReactComponent as IconArrowDown } from "../../../build/images/platformnps/arrowdown.svg";
// import FieldInput from "../FieldInput";
import Button from "../Button";
import MicroModal from "micromodal";
import { connection_platform } from "../../../services/api";
import axios from "axios";
import Select from "react-select";
import {
  getEmailResponsibleCall,
  getReasonNonComplianceCall,
  insertNonComplianceCall,
} from "../../../actions";

// let url_connection = `${connection_platform.type_connect}:${localStorage.getItem("pathname")}:${localStorage.getItem("port")}`
// let url_connection = `https://cloud.ingweb.com.br:8080`;
let url_connection = `${connection_platform.type_connect}://${connection_platform.ip_intern}:${connection_platform.port_backend_intern}`;

const RncCallCenterModal = ({ modalTitle, data }) => {
  const [reasons, setReasons] = useState([]);
  const [responsibles, setResponsibles] = useState([]);
  const [responsiblesSelected, setResponsiblesSelected] = useState("");
  const [reasonSelected, setReasonsSelected] = useState("");
  const [conclused, setConclused] = useState(false);
  const [textObservation, setTextObservation] = useState("");

  useEffect(() => {
    getResponsiblesRnc();
    getReasonsRnc();
  }, []);

  const getResponsiblesRnc = async () => {
    const response = await getEmailResponsibleCall();
    if (response.data !== "") {
      let returnedArray = response.data;
      returnedArray.map((todo) => {
        todo.label = todo.email;
      });
      setResponsibles(returnedArray);
    }
  };

  const getReasonsRnc = async () => {
    const response = await getReasonNonComplianceCall();
    if (response.data !== "") {
      let returnedArray = response.data;
      returnedArray.map((todo) => {
        todo.label = todo.description;
      });
      setReasons(returnedArray);
    }
  };

  const saveRncEvaluation = async () => {
    if (reasonSelected.id !== 0 && responsiblesSelected.id !== 0) {
      MicroModal.close("modal-component-rnc-modal");
      if (conclused) {
        await insertNonComplianceCall(
          textObservation,
          data,
          reasonSelected,
          responsiblesSelected,
          "now()",
          data.userid
        );
        //await axios.get(`${url_connection}/conn/insert-non-compliance?description=${textObservation}&idcdr=${data.cdrid}&id_reason_non_compliance=${reasonSelected.id}&user_insert=${data.userid}&id_email_responsible=${responsiblesSelected.id}&date_close=now()&user_close=${data.userid}`)
      } else {
        await insertNonComplianceCall(
          textObservation,
          data,
          reasonSelected,
          responsiblesSelected,
          "",
          ""
        );
        //await axios.get(`${url_connection}/conn/insert-non-compliance?description=${textObservation}&idcdr=${data.cdrid}&id_reason_non_compliance=${reasonSelected.id}&user_insert=${data.userid}&id_email_responsible=${responsiblesSelected.id}&date_close=&user_close=`);
      }
    }
  };

  const closeModal = () => {
    MicroModal.close("modal-component-rnc-modal");
  };

  const handleCheckConclused = () => {
    if (conclused) {
      setConclused(!conclused);
      document.getElementById("conclused-input").checked = false;
    } else {
      setConclused(!conclused);
      document.getElementById("conclused-input").checked = true;
    }
  };

  return (
    <div
      className="modal micromodal-slide"
      id="modal-component-rnc-modal"
      aria-hidden="true"
    >
      <div className={`modal__overlay`} aria-modal="true" tabIndex="-1">
        <div
          className="modal__container"
          role="dialog"
          style={{ padding: "24px", borderRadius: "8px" }}
        >
          <div className="modal-component__general">
            <div className="modal-component__general__header">
              <span>{modalTitle}</span>
              <div className="modal_close" onClick={() => closeModal()}>
                <IconCloseCircle />
              </div>
            </div>
            <div className="modal-component__general__body">
              <div className="modal-component__general__body-rnc">
                <div className="modal-component__general__body-msg__content__rnc">
                  <div className="modal-component__general__body-msg__content__rnc-block">
                    <span>Selecione o motivo da RNC</span>
                    <Select
                      isDisabled={false}
                      value={reasonSelected}
                      onChange={setReasonsSelected}
                      name="reason-rnc"
                      className="modal__content__form__group__input"
                      id="modal__content__form__group__label--empresa"
                      options={reasons}
                    />
                  </div>
                </div>
                <div className="modal-component__general__body-msg__content__rnc">
                  <div className="modal-component__general__body-msg__content__rnc-block">
                    <span>E-mail dos responsáveis</span>
                    <Select
                      isDisabled={false}
                      value={responsiblesSelected}
                      onChange={setResponsiblesSelected}
                      name="responsible-rnc"
                      className="modal__content__form__group__input"
                      id="modal__content__form__group__label--empresa"
                      options={responsibles}
                    />
                  </div>
                </div>
                <div className="modal-component__general__body-msg__content-block">
                  <div className="modal-component__general__body-msg__content-title">
                    <span>RNC</span>
                  </div>
                  <textarea
                    defaultValue={textObservation}
                    onChange={(event) => setTextObservation(event.target.value)}
                  />
                </div>
                <div className="modal-component__general__body-rnc__form">
                  <div className="modal-component__general__body-forms">
                    <div
                      className="modal-component__general__body-forms_item"
                      onClick={() => handleCheckConclused()}
                    >
                      <input
                        type="checkbox"
                        id="conclused-input"
                        name="conclused-input"
                        onClick={() => setConclused(!conclused)}
                        defaultChecked={conclused}
                      />
                      <span>Marcar como concluído</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="modal-component__general__body-actions">
              <Button
                label="Cancelar"
                theme="danger"
                action={() => closeModal()}
              />
              <Button
                label="Salvar"
                theme="primary"
                action={() => saveRncEvaluation()}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RncCallCenterModal;
